module.exports = __webpack_public_path__ + "static/media/payment-success.512f0cba.svg";